import { type CartControllerMessageV2 } from 'types/api/cart'

const isOutOfStockMessage = (message: CartControllerMessageV2): boolean => {
  return (
    message.scope === 'Offer' &&
    message.type === 'warn' &&
    message.messages.some((msg: string) => msg === 'offer.not.found')
  )
}

const isVoucherMessage = (message: CartControllerMessageV2): boolean => {
  return message.scope === 'voucher'
}

const isErrorMessage = (message: CartControllerMessageV2): boolean => {
  return message.type === 'error'
}
const isMpItemsRemovedMessage = (message: CartControllerMessageV2): boolean => {
  return message.scope === 'mpRemoved'
}

const isErxRemovedMessage = (message: CartControllerMessageV2): boolean =>
  message.scope === 'erxRemoved'

const getOutOfStockMessageList = (messages: CartControllerMessageV2[]) =>
  messages.filter(isOutOfStockMessage)

const getVoucherMessageList = (messages: CartControllerMessageV2[]) =>
  messages.filter(isVoucherMessage)

const getErrorMessageList = (messages: CartControllerMessageV2[]) =>
  messages.filter(isErrorMessage)
const getMpRemovedMessageList = (messages: CartControllerMessageV2[]) =>
  messages.filter(isMpItemsRemovedMessage)

const getErxRemovedMessageList = (messages: CartControllerMessageV2[]) =>
  messages.filter(isErxRemovedMessage)

export {
  getOutOfStockMessageList,
  getVoucherMessageList,
  getErrorMessageList,
  getMpRemovedMessageList,
  getErxRemovedMessageList,
}
